import { useCallback, useEffect, useRef, useState } from 'react';
import { useField } from '@unform/core';
import { Icone } from '../Icone';
import TextoTooltip from '../TooltipText';
import {
  ConteinerInputs,
  ConteinerIcone,
  BordaDeFoco,
  Conteiner,
  CampoInput,
  Titulo,
  TextoDeErro,
} from './styles';

export function EnvioArquivo({
  nome,
  placeholder,
  titulo,
  aoMudar,
  existeArquivo,
  desabilitado = false,
}) {
  const [arquivo, atribuirArquivo] = useState(null);
  const [nomeArquivo, atribuirNomeArquivo] = useState('');

  const inputRef = useRef(null);

  const { fieldName, registerField, defaultValue, error } = useField(nome);

  const converterParaBlob = useCallback(() => {
    const stringByte = atob(defaultValue.file);
    const listaDeBytes = [];
    const tamanhoFracao = 512;

    for (let deslocamento = 0; deslocamento < stringByte.length; deslocamento += tamanhoFracao) {
      const fracao = stringByte.slice(deslocamento, deslocamento + tamanhoFracao);

      const numerosByte = new Array(fracao.length);
      for (let i = 0; i < fracao.length; i++) {
        numerosByte[i] = fracao.charCodeAt(i);
      }

      const listaDeByte = new Uint8Array(numerosByte);
      listaDeBytes.push(listaDeByte);
    }

    return new Blob(listaDeBytes, { type: defaultValue.mimetype });
  }, [defaultValue]);

  const aoMudarValor = (event) => {
    if (aoMudar) aoMudar(event.target.value);

    atribuirNomeArquivo(event.target.files[0]?.name ?? '');
  };

  const baixar = () => {
    let a = document.createElement('a');
    document.body.appendChild(a);
    a.style.display = 'none';

    let blob = arquivo,
      url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = defaultValue.filename;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  useEffect(() => {
    if (aoMudar) aoMudar(inputRef.current.value);
  }, [inputRef, aoMudar]);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'files[0]',
    });
  }, [fieldName, registerField]);

  useEffect(() => {
    if (defaultValue) {
      atribuirArquivo(converterParaBlob());
      if (existeArquivo) {
        existeArquivo();
      }
    }
  }, [defaultValue, existeArquivo, converterParaBlob]);

  return (
    <>
      <Conteiner>
        {titulo ? <Titulo>{titulo}</Titulo> : null}
        <ConteinerInputs>
          <CampoInput
            ref={inputRef}
            onChange={aoMudarValor}
            disabled={desabilitado}
            type='file'
            invisible
            accept='.jpg,.jpeg,.png'
          />
          <CampoInput
            placeholder={placeholder}
            defaultValue={defaultValue}
            disabled={desabilitado}
            readOnly
            value={nomeArquivo}
            onClick={() => inputRef.current.click()}
          />
          <ConteinerIcone disabled={desabilitado} onClick={() => inputRef.current.click()}>
            <Icone nome='FaFileUpload' desabilitado={desabilitado} />
          </ConteinerIcone>
          {arquivo && (
            <>
              <ConteinerIcone onClick={() => baixar()}>
                <Icone nome='FaDownload' />
                <TextoTooltip>baixar imagem</TextoTooltip>
              </ConteinerIcone>
            </>
          )}
          <BordaDeFoco error={error} />
        </ConteinerInputs>
        {error && <TextoDeErro>{error}</TextoDeErro>}
      </Conteiner>
    </>
  );
}
